/* eslint-disable eqeqeq */
import { PillarsMenu } from '@/models/channels'

const toggleMenu = (store, { tab, context }) => {
  if (store.state.menuTab === tab && context !== 'placeholder') {
    store.dispatch('closeMenu', context)
  } else {
    store.dispatch('openMenu', tab)
  }
}

const toggleMenuState = store => {
  if (store.state.menuState === PillarsMenu.COMPACT) {
    store.dispatch('setMenuExpanded')
  } else {
    store.dispatch('setMenuCompact')
  }
}

const openMenu = (store, tab) => {
  const menuState =
    store.state.menuState !== PillarsMenu.CLOSED
      ? store.state.menuState
      : PillarsMenu.COMPACT

  store.commit('setMenuTab', tab)
  store.commit('setMenuState', menuState)
  store.commit('pillars/handleOpenPillars', menuState, { root: true })
}

const setMenuCompact = (store, { shouldHandleOpenPillars = true } = {}) => {
  if (store.state.menuState === PillarsMenu.CLOSED) {
    return
  }
  store.commit('setMenuState', PillarsMenu.COMPACT)
  if (shouldHandleOpenPillars) {
    store.commit('pillars/handleOpenPillars', PillarsMenu.COMPACT, {
      root: true
    })
  }
}

const setMenuExpanded = (store, { shouldHandleOpenPillars = true } = {}) => {
  if (store.state.menuState === PillarsMenu.CLOSED) {
    return
  }
  store.commit('setMenuState', PillarsMenu.EXPANDED)
  if (shouldHandleOpenPillars) {
    store.commit('pillars/handleOpenPillars', PillarsMenu.EXPANDED, {
      root: true
    })
  }
}

const closeMenu = store => {
  store.commit('setMenuState', PillarsMenu.CLOSED)
  store.commit('setMenuTab', undefined)
}

const handleMenu = (store, openPillars) => {
  if (!store.state.menuTab) return

  if (openPillars == 3) {
    store.dispatch('closeMenu')
  } else if (openPillars == 2) {
    store.dispatch('setMenuCompact', { shouldHandleOpenPillars: false })
  } else if (openPillars == 1) {
    store.dispatch('setMenuExpanded', { shouldHandleOpenPillars: false })
  }
}

export default {
  toggleMenu,
  toggleMenuState,
  openMenu,
  setMenuCompact,
  setMenuExpanded,
  closeMenu,
  handleMenu
}
